'use strict';

var _ = require('lodash');
var StrategyRecordDataService = function StrategyRecordDataService(configurationService, StrategyConstants, DowConstants, fcrService) {
  var data = StrategyConstants.DROP_DOWN_DATA;
  function extract(data, fn) {
    return _.chain(data).transform(fn).uniq().value();
  }
  function getConditionDataBuilders() {
    return {
      markets: function markets() {
        var markets = configurationService.getNonCodeShareMarkets();
        return extract(markets, function (result, current) {
          result.push(current.origin + '-' + current.destination);
        });
      },
      legs: function legs() {
        var legs = configurationService.getNonCodeShareLegs();
        return extract(legs, function (result, current) {
          result.push(current.origin + '-' + current.destination);
        });
      },
      origins: function origins() {
        var markets = configurationService.getNonCodeShareMarkets();
        return extract(markets, function (result, current) {
          result.push(current.origin);
        }).sort();
      },
      destinations: function destinations() {
        var markets = configurationService.getNonCodeShareMarkets();
        return extract(markets, function (result, current) {
          result.push(current.destination);
        }).sort();
      },
      flightNumbers: function flightNumbers() {
        var flightNumbers = configurationService.getFlightNumbers();
        return extract(flightNumbers, function (result, current) {
          result.push({
            value: current.flightNumber,
            dropdownVisibleValue: current.flightNumber
          });
        });
      },
      seasons: function seasons() {
        var seasons = configurationService.getSeasons();
        var events = configurationService.getEvents();
        return extract(_.concat(seasons, events), function (result, current) {
          if (current) {
            result.push(current.name);
          }
        });
      },
      marketEntities: function marketEntities() {
        var entities = configurationService.getEntities();
        return _.transform(_.filter(entities, {
          type: 'Market'
        }), function (result, current) {
          result.push({
            value: current.description,
            dropdownVisibleValue: current.description
          });
        });
      },
      flightEntities: function flightEntities() {
        var entities = configurationService.getEntities();
        return _.transform(_.filter(entities, {
          type: 'Flight'
        }), function (result, current) {
          result.push({
            value: current.description,
            dropdownVisibleValue: current.description
          });
        });
      },
      dowGroupsFlight: function dowGroupsFlight() {
        var data = configurationService.getFlightDowGroups();
        return _.transform(data, function (result, current) {
          result.push({
            value: current.name
          });
        });
      },
      dowGroupsMarket: function dowGroupsMarket() {
        var data = configurationService.getMarketDowGroups();
        return _.transform(data, function (result, current) {
          result.push({
            value: current.name
          });
        });
      },
      hostCarrier: function hostCarrier() {
        var hostCarrier = configurationService.getHostCarrier();
        return [{
          value: hostCarrier
        }];
      },
      operatingCarriers: function operatingCarriers() {
        var data = configurationService.getHostAndSubsidiaryCarriers();
        return _.transform(data, function (result, current) {
          result.push({
            value: current
          });
        });
      },
      workGroupEntities: function workGroupEntities() {
        var entities = configurationService.getEntities();
        return _.transform(_.filter(entities, {
          type: 'WorkGroup'
        }), function (result, current) {
          result.push({
            value: current.id,
            dropdownVisibleValue: current.description
          });
        });
      },
      poses: function poses() {
        var poses = configurationService.getPoses();
        return extract(poses, function (result, current) {
          result.push(current.spos);
        });
      },
      cabins: function cabins() {
        return configurationService.getDisplayableCabins();
      },
      classes: function classes() {
        return fcrService.getClassesFcrSorted();
      },
      classGroups: function classGroups() {
        return configurationService.getClassGroups();
      },
      userOversaleRisk: function userOversaleRisk() {
        return data.userOversaleRisk;
      },
      curtainControlIndicators: function curtainControlIndicators() {
        return data.curtainControlIndicators;
      },
      yesno: function yesno() {
        return data.yesno;
      },
      comFareRangeTypes: function comFareRangeTypes() {
        return data.comFareRangeTypes;
      },
      comFareMatchRuleTypes: function comFareMatchRuleTypes() {
        return data.comFareMatchRuleTypes;
      },
      dow: function dow() {
        return DowConstants.ALL_DOW_IDS_FULL;
      },
      segmentTypes: function segmentTypes() {
        return data.segmentTypes;
      },
      flightTags: function flightTags() {
        return configurationService.getFlightTagNames();
      }
    };
  }
  function getOperandData(mapping, fieldId) {
    var dataKey = mapping[fieldId];
    var conditionDataBuilders = getConditionDataBuilders();
    var dataBuilderFunction = conditionDataBuilders[dataKey];
    if (fieldId === '') {
      return [];
    } else if (dataBuilderFunction) {
      return dataBuilderFunction();
    }
    return [];

    // we should throw an error here
    // throw Error('Mapping not found for: ' + fieldId);
  }
  return {
    getOperandData: getOperandData
  };
};
StrategyRecordDataService.$inject = ['ConfigurationService', 'StrategyConstants', 'DowConstants', 'FcrService'];
module.exports = StrategyRecordDataService;